import _regeneratorRuntime from "/root/code/node_modules/next/node_modules/@babel/runtime/regenerator";
import _extends from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteral from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useEffect, useContext, useMemo } from "react";
import { Box, SearchBar as SearchBarComponent, styled, themeGet, Highlighter, Span } from "@catchoftheday/cg-components";
import debounce from "lodash.debounce";
import useSWR from "swr";
import { css } from "@emotion/react";
import { fetcher } from "../../api/index";
import { searchRedirectUrl } from "../../api/searchRedirectUrl";
import { getQueryStringValue } from "../../utilities/index";
import { HeaderContext } from "../../context";
import { encodeSearchTerm } from "../../utilities/url";
import { jsx as ___EmotionJSX } from "@emotion/react";
var SearchItemContainer = styled(Box)(_templateObject(), function (props) {
  return props.isHighlighted ?
  /*#__PURE__*/

  /*#__PURE__*/
  css("background-color:", themeGet("colors.ui.dropDownBg")(props), ";color:", themeGet("colors.ui.dropDownText")(props), ";" + (true ? "" : ";label:SearchItemContainer;"), true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", true ? "" : ";label:SearchItemContainer;") : "background-color: white; color: #333;";
}, themeGet("colors.ui.dropDownText"), themeGet("colors.ui.dropDownBg"));

function transformSearchData(searchData) {
  var result = searchData.reduce(function (acc, curr) {
    var value = curr.value,
        categories = curr.categories;
    var filteredCategories = categories ? categories.filter(function (cat) {
      return cat;
    }) : [];
    var searchTermOnlySuggestion = [{
      title: value
    }];
    var suggestions = filteredCategories.length > 0 ? searchTermOnlySuggestion.concat(filteredCategories.map(function (cat) {
      return {
        title: value,
        value: cat
      };
    })) : searchTermOnlySuggestion;
    return acc.concat(suggestions);
  }, []);
  return result;
}

export var SearchBar = function SearchBar(props) {
  var headerContext = useContext(HeaderContext);

  var _useState = useState(""),
      searchTerm = _useState[0],
      setSearchTerm = _useState[1];

  var _useState2 = useState(""),
      inputTerm = _useState2[0],
      setInputTerm = _useState2[1];

  var _useState3 = useState(false),
      showSearchData = _useState3[0],
      setShowSearchData = _useState3[1];

  var debouncedSetSearchTerm = useMemo(function () {
    return debounce(setSearchTerm, 150);
  }, [setSearchTerm]);

  var _useSWR = useSWR(function () {
    return searchTerm ? "/autocomplete/2?query=".concat(encodeSearchTerm(searchTerm)) : null;
  }, fetcher, {
    dedupingInterval: 0
  }),
      data = _useSWR.data,
      isValidating = _useSWR.isValidating;

  var renderSearchItem = function renderSearchItem(_ref) {
    var _itemData$value;

    var itemData = _ref.itemData,
        isHighlighted = _ref.isHighlighted;
    return ___EmotionJSX(SearchItemContainer, {
      isHighlighted: isHighlighted,
      fontWeight: "light",
      fontSize: "sm",
      px: "26px",
      py: "5px"
    }, ___EmotionJSX(Highlighter, {
      highlight: inputTerm,
      text: itemData.title,
      reverse: true
    }), ___EmotionJSX(Span, {
      color: "secondary",
      fontSize: "xs"
    }, itemData.value ? " in ".concat((_itemData$value = itemData.value) === null || _itemData$value === void 0 ? void 0 : _itemData$value.name) : ""));
  };

  var onInputChange = function onInputChange(value, reason) {
    if (reason.onChange) {
      debouncedSetSearchTerm.cancel(); // Only search if input term is different from current search term

      debouncedSetSearchTerm(value); // Update input term state to match with user input

      setInputTerm(value); // CLear suggestions if input term is different from current search term

      if (value.trim() != searchTerm.trim()) {
        setShowSearchData(false);
      }
    }
  };

  var searchData = (data === null || data === void 0 ? void 0 : data.data) || [];
  var suggestions = searchData && searchData.length > 0 ? transformSearchData(searchData) : [];

  function navigateToSearchPage(_x, _x2) {
    return _navigateToSearchPage.apply(this, arguments);
  }

  function _navigateToSearchPage() {
    _navigateToSearchPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(term, category) {
      var encodedSearchTerm, query, params, url, redirectUrl;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              encodedSearchTerm = encodeSearchTerm(term);
              query = "/search?query=".concat(encodedSearchTerm);
              params = "&search_src=topbar&ac=0".concat(category ? "&f[category]=".concat(category.id, "&acs=1") : "");
              url = "".concat(query).concat(encodeURI(params));
              _context.next = 6;
              return searchRedirectUrl(term);

            case 6:
              redirectUrl = _context.sent;

              if (!redirectUrl) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", location.assign(redirectUrl));

            case 9:
              window.location.assign(url);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _navigateToSearchPage.apply(this, arguments);
  }

  var urlSearchQuery = getQueryStringValue("query");
  useEffect(function () {
    if (urlSearchQuery) {
      setInputTerm(urlSearchQuery);
      setSearchTerm(urlSearchQuery);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  useEffect(function () {
    if (searchTerm) {
      setShowSearchData(true);
    }
  }, [searchTerm]);
  return ___EmotionJSX(SearchBarComponent, _extends({
    isLoading: !!searchTerm && isValidating,
    onInputChange: onInputChange,
    defaultValue: urlSearchQuery,
    onItemSelected: function onItemSelected(itemData) {
      var term = (itemData === null || itemData === void 0 ? void 0 : itemData.title) || inputTerm;
      var category = itemData === null || itemData === void 0 ? void 0 : itemData.value;

      if (headerContext.onSearchChange) {
        headerContext.onSearchChange({
          query: term,
          "f[category]": category ? category.id : undefined,
          acs: "1"
        });
      } else {
        navigateToSearchPage(term, category);
      }
    },
    onSearchButtonClicked: function onSearchButtonClicked() {
      if (headerContext.onSearchChange) {
        headerContext.onSearchChange({
          query: inputTerm
        });
      } else {
        navigateToSearchPage(inputTerm, null);
      }
    },
    data: showSearchData ? suggestions : [],
    renderListItem: renderSearchItem
  }, props));
};
export default SearchBar;